import { render } from "./proposedUniqueBlocks.vue?vue&type=template&id=e6bb710e&ts=true"
import script from "./proposedUniqueBlocks.vue?vue&type=script&lang=ts"
export * from "./proposedUniqueBlocks.vue?vue&type=script&lang=ts"

import "./proposedUniqueBlocks.vue?vue&type=style&index=0&id=e6bb710e&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__